// src/lib/tekst.js
// Tekstbehandling der bruges af både kunde-appen og admin-panelet.
// Rene funktioner uden kendskab til DOM'ens opbygning — derfor kan de
// deles, hvor toast og modaler ikke kan (de to apper bruger forskellige
// CSS-klasser til det samme).

/** Afkoder HTML-entiteter i tekst der kommer fra en ekstern kilde. */
export function decodeHtml(str) {
  if (!str) return str;
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

/**
 * Escaper tekst der indsættes i HTML.
 *
 * Maskinnavne og noter skrives af kunderne selv og vises også i
 * admin-panelet. Uden escaping kan en kunde navngive sin maskine
 * <img src=x onerror=...> og få kode til at køre i administratorens
 * browser — med administratorens login.
 */
export function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/**
 * Til visning af tekst fra databasen, der kan indeholde HTML-entiteter.
 *
 * Produktnavne er skrabet fra dk-tec.dk og ligger i databasen med
 * entiteterne intakte — fx "Fr&#xE6;ser&#x20;hydraulisk". Tidligere blev
 * de sat råt ind i siden, saa browseren afkodede dem undervejs. Da
 * escaping blev indfoert mod XSS, blev & til &amp;, og koderne kom til at
 * staa bogstaveligt paa skaermen.
 *
 * Rækkefølgen er vigtig: afkod foerst, escape derefter. Omvendt ville
 * escapingen blive afkodet igen, og saa var beskyttelsen vaek.
 *
 * Bemærk at det ogsaa paavirker layoutet: "&#x20;" er ikke et mellemrum,
 * saa et uafkodet navn bliver ét uafbrydeligt ord, der presser tabeller
 * bredere end skaermen.
 */
export function visTekst(s) {
  return esc(decodeHtml(s));
}

/**
 * Escaper en værdi der skal stå som JavaScript-streng i et onclick-attribut.
 *
 * Erstatter mønsteret .replace(/'/g,"\'"), som optrådte flere steder i
 * koden som escaping. Det gjorde intet: "\'" er blot ' i JavaScript.
 */
export function escJs(s) {
  return String(s == null ? '' : s)
    .replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;')
    .replace(/</g, '\\u003C').replace(/\r?\n/g, '\\n');
}
